import React from "react";
import "./checkbox.css";

function Checkbox({ id, name, checked = false, onChange }) {


    return <div className="checkbox">
        <input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} />
        <span className="circle"></span>
        <label htmlFor={id} className="text"></label>
    </div>;
}

export default React.memo(Checkbox);

